import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const getAllGeneratedBlogs = async (
  page: number,
  perPage: number,
): Promise<any> => {
  const url = urls.generatedBlogsList + `?page=${page}&per_page=${perPage}`;
  try {
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const generateBlog = async (body: any): Promise<any> => {
  try {
    const callParams = await getCallParams("POST", body);
    const response: any = await makeCall(urls.generateBlog, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const publishBlog = async (blogId: string, body: any): Promise<any> => {
  const url = urls.blogComments + blogId + "/content";
  try {
    const callParams = await getCallParams("PATCH", body);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const rejectBlog = async (blogId: string): Promise<any> => {
  const url = urls.blogComments + blogId + "/reject";
  try {
    const callParams = await getCallParams("PATCH");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
